"use client";
import type {
  GetSongActions,
  SongAction,
} from "~/components/audio/songActions.types";
import type { Song } from "~/types";


export const getPublicDemoSongActions: GetSongActions = (
  song: Song,
  { router, getState },
): SongAction[] => {
  return [{ panel: "lyrics", visible: !!song.lyrics }];
};
